import React from 'react';
import SectionTitle from '../common/SectionTitle';

const FaqTwo = () => {
  return (
    <>
      <section className='faq-section ptb-120 bg-light'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-7 col-12'>
              <SectionTitle subtitle='FAQ' title='Frequently Asked Questions' description='Have questions? We’re here to help.
              Browse through our FAQs to find quick answers and helpful information about how our platform works.' centerAlign/>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-lg-7 col-12'>
              <div className='accordion faq-accordion' id='accordionExample'>
                <div className='accordion-item border border-2 active'>
                  <h5 className='accordion-header' id='faq-1'>
                    <button
                      className='accordion-button'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-1'
                      aria-expanded='true'
                    >
                      What payment methods do you support?
                    </button>
                  </h5>
                  <div
                    id='collapse-1'
                    className='accordion-collapse collapse show'
                    aria-labelledby='faq-1'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      We support a wide range of payment methods, including:
                      <ul>
                        <li>Credit and debit cards (Visa, Mastercard, etc.)</li>
                        <li>Digital wallets (Apple Pay, Google Pay)</li>
                        <li>Bank transfers (where applicable)</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='accordion-item border border-2'>
                  <h5 className='accordion-header' id='faq-2'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-2'
                      aria-expanded='false'
                    >
                      How long does it take to process a payment?
                    </button>
                  </h5>
                  <div
                    id='collapse-2'
                    className='accordion-collapse collapse'
                    aria-labelledby='faq-2'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Most payments are processed in real time (within seconds).
                      Settlement times may vary depending on the bank and payment method.
                    </div>
                  </div>
                </div>
                <div className='accordion-item border border-2'>
                  <h5 className='accordion-header' id='faq-3'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-3'
                      aria-expanded='false'
                    >
                      What are the transaction fees?
                    </button>
                  </h5>
                  <div
                    id='collapse-3'
                    className='accordion-collapse collapse'
                    aria-labelledby='faq-3'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      We charge a small fee per transaction. Fees may vary depending on: <br/>
                      <ul>
                        <li>Payment method</li>
                        <li>Transaction volume</li>
                        <li>Merchant agreement</li>
                      </ul>
                      Please contact us for detailed pricing.
                    </div>
                  </div>
                </div>

                <div className='accordion-item border border-2'>
                  <h5 className='accordion-header' id='faq-4'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-4'
                      aria-expanded='false'
                    >
                      Can I issue refunds or cancel transactions?
                    </button>
                  </h5>
                  <div
                    id='collapse-4'
                    className='accordion-collapse collapse'
                    aria-labelledby='faq-4'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Yes. You can: <br/>
                      <ul>
                        <li>Cancel a transaction before it is settled (void)</li>
                        <li>Issue full or partial refunds after settlement</li>
                      </ul>
                      These actions can be performed via API or the dashboard.
                    </div>
                  </div>
                </div>

                <div className='accordion-item border border-2'>
                  <h5 className='accordion-header' id='faq-5'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-5'
                      aria-expanded='false'
                    >
                      Do you support international payments?
                    </button>
                  </h5>
                  <div
                    id='collapse-5'
                    className='accordion-collapse collapse'
                    aria-labelledby='faq-5'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Yes, our platform supports payments from multiple countries and currencies, allowing you to serve customers globally.
                    </div>
                  </div>
                </div>
                <div className='accordion-item border border-2'>
                  <h5 className='accordion-header' id='faq-6'>
                    <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapse-6'
                        aria-expanded='false'
                    >
                      How can I integrate your PSP into my system?
                    </button>
                  </h5>
                  <div
                      id='collapse-6'
                      className='accordion-collapse collapse'
                      aria-labelledby='faq-6'
                      data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      We provide:
                      <ul>
                        <li>REST APIs</li>
                        <li>SDKs</li>
                        <li>Detailed documentation</li>
                      </ul>
                      Integration is simple and can be completed in a few steps.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqTwo;
